import mitt from 'mitt';

export enum EventBusEvents {
  JobsUpdated = 'jobsUpdated',
  JobCompleted = 'jobCompleted',
}

export type JobCompletedPayload = {
  jid: string;
  kind: string;
};

export type JobEvents = {
  jobsUpdated: void;
  jobCompleted: JobCompletedPayload;
};

export const jobEventBus = mitt<JobEvents>();
